import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { actions as userActions } from '@redux/modules/user';
import { enableScroll } from './useScrollBlock';

const useCloseMenu = () => {
  const dispatch = useDispatch();

  const closeMenu = useCallback(() => {
    enableScroll();

    dispatch(userActions.closeMenu());
  }, [dispatch]);

  return closeMenu;
};

export default useCloseMenu;
